import React from 'react';

import {
  AnimatePresence,
  motion
} from 'motion/react';

import {
  kaizenNumberTransition
} from '../../lib/kaizenMotion';


interface AnimatedNumberProps {

  value:
    number |
    null;

  suffix?:
    string;

  prefix?:
    string;

  fallback?:
    string;

  className?:
    string;
}


export const AnimatedNumber:
React.FC<AnimatedNumberProps> = ({
  value,
  suffix = '',
  prefix = '',
  fallback = '--',
  className = ''
}) => {

  const display =
    typeof value === 'number'
      ? `${prefix}${value}${suffix}`
      : fallback;


  return (

    <span
      className={`
        inline-grid
        overflow-hidden
        align-baseline
        ${className}
      `}
      aria-label={display}
    >

      <AnimatePresence
        initial={false}
        mode="popLayout"
      >

        <motion.span
          key={display}
          className="
            col-start-1
            row-start-1
            inline-block
          "
          initial={{
            opacity: 0,
            y: 4
          }}
          animate={{
            opacity: 1,
            y: 0
          }}
          exit={{
            opacity: 0,
            y: -4
          }}
          transition={
            kaizenNumberTransition
          }
        >
          {display}
        </motion.span>

      </AnimatePresence>

    </span>
  );
};